export async function registerServiceWorker() {
    if (!('serviceWorker' in navigator)) {
        return null;
    }
    try {
        const registration = await navigator.serviceWorker.register('/sw.js');
        return registration;
    } catch (e) {
        return null;
    }
}

export function urlBase64ToUint8Array(base64: string) {
    const padding = '='.repeat((4 - (base64.length % 4)) % 4);
    const base64Safe = (base64 + padding).replace(/-/g, '+').replace(/_/g, '/');
    const raw = window.atob(base64Safe);
    const out = new Uint8Array(raw.length);

    for (let i = 0; i < raw.length; ++i) out[i] = raw.charCodeAt(i);
    return out;
}

// Зашитый VAPID публичный ключ
const VAPID_PUBLIC_KEY = 'BIWWnzicmoystoNq3ipAiCPdGgbRVbF3-IeehLiE5y3GAt1_t9dLf2eZZOckLm6vbM4Uo5fxzIiV6TecIgwty_E';


export async function createPushSubscription() {
    const reg = await registerServiceWorker();
    if (!reg) {
        console.error('ServiceWorker not registered');
        throw new Error('ServiceWorker not registered');
    }
    const perm = await Notification.requestPermission();

    if (perm !== 'granted') {
        throw new Error('Permission denied');
    }
    const vapid = VAPID_PUBLIC_KEY.trim();

    if (!vapid) {

        throw new Error('VAPID key not configured');
    }
    const applicationServerKey = urlBase64ToUint8Array(vapid);
    const subscription = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: applicationServerKey,
    });
    return subscription;
}

export async function removePushSubscription() {

    const reg = await registerServiceWorker();
    if (!reg) {
        throw new Error('ServiceWorker not registered');
    }
    const subscription = await reg.pushManager.getSubscription();

    if (!subscription) {
        console.warn(' No active subscription found');
        return null;
    }


    const result = await subscription.unsubscribe();

    return subscription;
}
